import React, { useMemo, useEffect, useRef } from 'react';
import BackIcon from '../../../../assets/svg/back.svg?react';
import CreditsGrayIcon from '../../../../assets/svg/credits-gray.svg?react';
import ExportSuccessIcon from '../../../../assets/svg/export-success.svg?react';
import DownloadIcon from '../../../../assets/svg/download-black.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJFake3dExport.module.less';
import FJSingleRadio from '../../../../common/components/FJRadio/FJSingleRadio';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import FJArcProgress from '../../../../common/components/FJArcProgress/FJArcProgress';
import FJIconButton from '../../../../common/components/FJIconButton/FJIconButton';
import FJConstant from '../../../../constants/FJConstant';
import PropTypes from 'prop-types';
import { FORMATE, GIF_RESOLUTION, VIDEO_RESOLUTION } from '../../../../config/dataConfig/FJFake3dData';
import FJToolContentBG from '../../../../common/components/FJToolContentBG/FJToolContentBG';
import ApplyIcon from '../../../../assets/svg/apply.svg?react';
import AddMediaIcon from '../../../../assets/svg/add-to-media.svg?react';
import FJFake3dExportConfig from '../../../../config/FJFake3dExportConfig.js';

const FJFake3dExport = props => {
    const {
        settingStep = FJConstant.DEFAULT,
        onExport,
        exportFormate,
        exportResolution,
        onExportFormateChange,
        onExportResolutionChange,
        backExport,
        exportProgress,
        download,
        useApplyButton,
        onApply,
        onAddToMediaLibrary,
    } = props;
    const _onBack = () => {
        backExport();
    };
    const _onResolutionChange = value => {
        onExportResolutionChange(value);
    };

    const resolutionList = useMemo(() => {
        if (exportFormate === 'video') {
            return VIDEO_RESOLUTION;
        } else {
            return GIF_RESOLUTION;
        }
    }, [exportFormate]);
    const _onFormateChange = value => {
        onExportFormateChange(value);
        const list = value === 'video' ? VIDEO_RESOLUTION : GIF_RESOLUTION;
        const resolution = FJFake3dExportConfig.getExportResolution(value) || list[list.length - 1].type;
        onExportResolutionChange(resolution);
    };
    useEffect(() => {
        FJFake3dExportConfig.setExportResolution(exportFormate, exportResolution);
    }, [exportFormate, exportResolution]);
    const renderExportSettingDom = () => {
        const left = `${FORMATE.indexOf(exportFormate) * 214 + 3}px`;
        const useCredit = resolutionList.find(item => item.type === exportResolution)?.price || 1;
        return (
            <div className={styles.setting_box}>
                <ul className={styles.tab}>
                    {FORMATE.map(value => {
                        return (
                            <li
                                key={value}
                                className={styles.text}
                                style={exportFormate === value ? { opacity: 1 } : null}
                                onClick={() => {
                                    _onFormateChange(value);
                                }}
                            >
                                {FJLocalStore._(value)}
                            </li>
                        );
                    })}
                    <li className={styles.bk} style={{ left: left }} />
                </ul>
                <div className={styles.setting_title}>{FJLocalStore._('resolution')}</div>
                {resolutionList.map(item => (
                    <div
                        className={styles.resolution_item}
                        key={item.type}
                        onClick={() => _onResolutionChange(item.type)}
                    >
                        <div className={styles.resolution_left}>
                            <FJSingleRadio className={styles.radio} active={item.type === exportResolution} />
                            <div className={styles.resolution_text}>{item.type + 'P'}</div>
                        </div>
                        <div className={styles.resolution_right}>
                            <CreditsGrayIcon />
                            <div className={styles.credits}>{item.price}</div>
                        </div>
                    </div>
                ))}
                <FJGenerateButton
                    className={styles.export_btn}
                    text={'export'}
                    onClick={onExport}
                    useCredit={useCredit}
                />
            </div>
        );
    };

    const renderExportingDom = () => {
        const exportText =
            exportFormate === 'video' ? FJLocalStore._('exporting-video') : FJLocalStore._('exporting-gif');
        return (
            <div className={styles.exporting_box}>
                <FJArcProgress
                    percent={exportProgress}
                    boxClassName={styles.progress}
                    valueClassName={styles.progress_text}
                    fractionDigits={0}
                />
                <div className={styles.export_text}>{exportText}</div>
                <div className={styles.cancel} onClick={_onBack}>
                    {FJLocalStore._('cancel')}
                </div>
            </div>
        );
    };
    const renderSuccessDom = () => {
        const canApply = useApplyButton && exportFormate === 'video';
        return (
            <div className={styles.exported_box}>
                <ExportSuccessIcon />
                <div className={styles.exported_text}>{FJLocalStore._('exported-successfully')}</div>
                <FJIconButton
                    className={styles.download_btn}
                    icon={<DownloadIcon />}
                    text={FJLocalStore._('download')}
                    onClick={download}
                />

                {window.isEditPage && (
                    <FJIconButton
                        className={styles.add_media_button}
                        text={FJLocalStore._(canApply ? 'apply' : 'add-to-media')}
                        icon={canApply ? <ApplyIcon /> : <AddMediaIcon />}
                        type={'gradient'}
                        onClick={canApply ? onApply : onAddToMediaLibrary}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <div className={styles.header}>
                <BackIcon className={styles.back} onClick={_onBack} />
                <div className={styles.title}>{FJLocalStore._('export-setting')}</div>
                <div />
            </div>
            <FJToolContentBG className={styles.main_box} active={settingStep === FJConstant.SETTING}>
                {renderExportSettingDom()}
            </FJToolContentBG>
            <FJToolContentBG className={styles.main_box} active={settingStep === FJConstant.GENERATING}>
                {renderExportingDom()}
            </FJToolContentBG>
            <FJToolContentBG BG className={styles.main_box} active={settingStep === FJConstant.SUCCESS}>
                {renderSuccessDom()}
            </FJToolContentBG>
        </>
    );
};

FJFake3dExport.propTypes = {
    settingStep: PropTypes.string,
    onExport: PropTypes.func,
    exportFormate: PropTypes.string,
    exportResolution: PropTypes.string,
    onExportFormateChange: PropTypes.func,
    onExportResolutionChange: PropTypes.func,
    backExport: PropTypes.func,
    exportProgress: PropTypes.number,
    download: PropTypes.func,
    useApplyButton: PropTypes.bool,
    onApply: PropTypes.func,
    onAddToMediaLibrary: PropTypes.func,
};
export default FJFake3dExport;
